export default function VRHeroSection() {
  return (
    <section className="relative w-full h-[80vh] min-h-[620px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/8146a5b6e2e462345459ceb6dd674cc9.jpg"
        alt="Vacation rentals in Highlands, NC — luxury mountain cabins in the Blue Ridge Mountains"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/60" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ 2026 Guide</p>
        <h1 className="font-cormorant text-5xl md:text-7xl text-white font-light leading-none mb-6 max-w-4xl">
          Best Vacation Rentals<br /><em className="italic">in Highlands, NC</em>
        </h1>
        <p className="text-white/75 font-jost text-sm leading-relaxed max-w-2xl mb-8">
          A curated guide to the top vacation rentals in Highlands, North Carolina — from luxury mountain cabins near Glen Falls to charming retreats steps from downtown. Updated for 2026.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/60 text-xs font-jost tracking-wide">
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-line text-[#C9A96E]" />
            </div>
            Highlands, North Carolina
          </span>
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-[#C9A96E]" />
            </div>
            Real Properties Only
          </span>
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-line text-[#C9A96E]" />
            </div>
            Ranked by Guest Experience
          </span>
        </div>
      </div>
    </section>
  );
}
